module.exports = __webpack_public_path__ + "static/img/zhuanli-4.79a35401.png";